import React from 'react'

const SvgFeature31 = props => (
  <svg viewBox='0 0 694.67 315.8' {...props}>
    <defs>
      <linearGradient
        id='feature3-1_svg__unname_19'
        x1={526.95}
        y1={115.45}
        x2={526.95}
        y2={113.79}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.66} stopColor='#fd5c1f' />
        <stop offset={0.66} stopColor='#8796aa' />
      </linearGradient>
      <linearGradient
        id='feature3-1_svg__unname_19-2'
        x1={529.29}
        y1={119.58}
        x2={529.29}
        y2={117.93}
        xlinkHref='#feature3-1_svg__unname_19'
      />
      <linearGradient
        id='feature3-1_svg__unname_19-3'
        x1={529.29}
        y1={123.72}
        x2={529.29}
        y2={122.07}
        xlinkHref='#feature3-1_svg__unname_19'
      />
      <linearGradient
        id='feature3-1_svg__unname_19-4'
        x1={214.95}
        y1={217.45}
        x2={214.95}
        y2={215.79}
        xlinkHref='#feature3-1_svg__unname_19'
      />
      <linearGradient
        id='feature3-1_svg__unname_19-5'
        x1={217.29}
        y1={221.58}
        x2={217.29}
        y2={219.93}
        xlinkHref='#feature3-1_svg__unname_19'
      />
      <linearGradient
        id='feature3-1_svg__unname_19-6'
        x1={217.29}
        y1={225.72}
        x2={217.29}
        y2={224.07}
        xlinkHref='#feature3-1_svg__unname_19'
      />
      <style>
        {
          '.feature3-1_svg__cls-1,.feature3-1_svg__cls-4{fill:#8796aa}.feature3-1_svg__cls-2{fill:#f4f8fa;stroke:#dae0e5}.feature3-1_svg__cls-13,.feature3-1_svg__cls-14,.feature3-1_svg__cls-2{stroke-miterlimit:10}.feature3-1_svg__cls-5{fill:#fd5c1f}.feature3-1_svg__cls-4{font-size:12px;font-family:SourceHanSansCN-Normal-GBpc-EUC-H,Source Han Sans CN;letter-spacing:.02em}.feature3-1_svg__cls-6{fill:#252a3a}.feature3-1_svg__cls-13,.feature3-1_svg__cls-14{fill:none;stroke:#8796aa}.feature3-1_svg__cls-13{stroke-dasharray:4 4}.feature3-1_svg__cls-14{stroke-dasharray:3 3}'
        }
      </style>
    </defs>
    <g id='feature3-1_svg__\u56FE\u5C42_2' data-name='\u56FE\u5C42 2'>
      <g id='feature3-1_svg__\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
        <path
          className='feature3-1_svg__cls-1'
          d='M609 35.8h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-7 0h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm3 7h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm4-3h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4z'
        />
        <path className='feature3-1_svg__cls-2' d='M107.73 85.86h170v60h-170z' />
        <path className='feature3-1_svg__cls-1' d='M287.48 114.86h114v2h-114z' />
        <path className='feature3-1_svg__cls-1' d='M400.9 109.86l8 6-8 6' />
        <text
          transform='translate(296.52 14.08)'
          fill='#fd5c1f'
          fontSize={16}
          fontFamily='SourceHanSansCN-Medium-GBpc-EUC-H,Source Han Sans CN'
          letterSpacing='.03em'
        >
          {'\u667A\u80FD\u65AD\u70B9\u7EED\u4F20'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(303.18 208.34)'>
          {'\u518D\u6B21\u53D1\u9001\u4F20\u8F93\u6307\u4EE4'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(385.18 172.34)'>
          {'\u89E6\u53D1\u65AD\u70B9\u7EED\u4F20\u673A\u5236'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(335.18 104.34)'>
          {'\u4F20\u8F93'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(145.96 119.85)'>
          {'\u6587\u4EF6A'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(232.96 119.85)'>
          {'\u6587\u4EF6B'}
        </text>
        <path
          className='feature3-1_svg__cls-5'
          d='M353.81 146.23a35.5 35.5 0 00-8.36 1.19l1.89 1.36a18.26 18.26 0 01-6.59 0v5.57c1.94.52 8.32.14 11.13-1l-.88-1.05a26 26 0 012.81-.12 29.75 29.75 0 018.37 1.16v-5.92a36 36 0 00-8.37-1.19z'
        />
        <path
          className='feature3-1_svg__cls-6'
          d='M362.69 167.84a24.9 24.9 0 00-4.7.92v1.65a33.56 33.56 0 01-8.46.78 34 34 0 01-8.27-1.84v-5.89c2.29 1.21 6.63 2 10.2 2a33 33 0 005.88-.56l-.28-1.47a20.29 20.29 0 015.63-1.42zM359 154.46a29.63 29.63 0 00-5.84.71l1 1.55a24.17 24.17 0 01-6 .55 27.91 27.91 0 01-10.27-2.06v5.9a28.93 28.93 0 008.93 1.55 29.61 29.61 0 009.42-1.43l-.27-.72a21.85 21.85 0 013-.19 24.06 24.06 0 016 .59V155a35.62 35.62 0 00-5.97-.54z'
        />
        <path
          className='feature3-1_svg__cls-1'
          d='M353.38 135.74a23 23 0 0120.9 20.91h2a25 25 0 00-22.91-22.92zM328.47 156.65a23 23 0 0120.91-20.91v-2a25 25 0 00-22.92 22.92zM349.38 181.55a23 23 0 01-20.91-20.9h-2a25 25 0 0022.92 22.91zM374.28 160.65a23 23 0 01-20.9 20.9v2a25 25 0 0022.91-22.91z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M133 103.86h-14.22v24h19.86V109zm-12.57 22.34v-20.69h10.76v5H137v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M122.09 113.79h7.73v1.66h-7.73zM122.09 117.93h12.41v1.66h-12.41zM122.09 122.07h12.41v1.66h-12.41zM221 103.86h-14.22v24h19.86V109zm-12.57 22.34v-20.69h10.76v5H225v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M210.09 113.79h7.73v1.66h-7.73zM210.09 117.93h12.41v1.66h-12.41zM210.09 122.07h12.41v1.66h-12.41z'
        />
        <path className='feature3-1_svg__cls-2' d='M420.73 85.86h170v60h-170z' />
        <text className='feature3-1_svg__cls-4' transform='translate(460.96 119.85)'>
          {'\u6587\u4EF6A'}
        </text>
        <path
          className='feature3-1_svg__cls-5'
          d='M446 103.86h-14.22v24h19.86V109zm-12.57 22.34v-20.69h10.76v5H450v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M435.09 113.79h7.73v1.66h-7.73zM435.09 117.93h12.41v1.66h-12.41zM435.09 122.07h12.41v1.66h-12.41z'
        />
        <text className='feature3-1_svg__cls-4' transform='translate(548.96 119.85)'>
          {'\u6587\u4EF6B'}
        </text>
        <path d='M534 103.86h-14.22v24h19.86V109zm-12.57 22.34v-20.69h10.76v5H538v15.69z' />
        <path fill='url(#feature3-1_svg__unname_19)' d='M523.09 113.79h7.73v1.66h-7.73z' />
        <path fill='url(#feature3-1_svg__unname_19-2)' d='M523.09 117.93h12.41v1.66h-12.41z' />
        <path fill='url(#feature3-1_svg__unname_19-3)' d='M523.09 122.07h12.41v1.66h-12.41z' />
        <path className='feature3-1_svg__cls-2' d='M107.73 187.86h170v60h-170z' />
        <path className='feature3-1_svg__cls-1' d='M288.48 216.86h114v2h-114z' />
        <path className='feature3-1_svg__cls-1' d='M401.9 211.86l8 6-8 6' />
        <text className='feature3-1_svg__cls-4' transform='translate(323.18 234.34)'>
          {'\u518D\u6B21\u4F20\u8F93'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(146.96 221.85)'>
          {'\u6587\u4EF6A'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(126.85 275.85)'>
          {'\u53D1\u9001\u5B8C\u6210'}
          <tspan x={0} y={14.4}>
            {'\u4E0D\u518D\u8FDB\u884C\u53D1\u9001'}
          </tspan>
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(217.85 275.85)'>
          {'\u4EC5\u53D1\u9001\u7F3A\u5931\u7684\u90E8\u5206'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(233.96 221.85)'>
          {'\u6587\u4EF6B'}
        </text>
        <path
          className='feature3-1_svg__cls-5'
          d='M134 205.86h-14.22v24h19.86V211zm-12.57 22.34v-20.69h10.76v5H138v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M123.09 215.79h7.73v1.66h-7.73zM123.09 219.93h12.41v1.66h-12.41zM123.09 224.07h12.41v1.66h-12.41z'
        />
        <path d='M222 205.86h-14.22v24h19.86V211zm-12.57 22.34v-20.69h10.76v5H226v15.69z' />
        <path fill='url(#feature3-1_svg__unname_19-4)' d='M211.09 215.79h7.73v1.66h-7.73z' />
        <path fill='url(#feature3-1_svg__unname_19-5)' d='M211.09 219.93h12.41v1.66h-12.41z' />
        <path fill='url(#feature3-1_svg__unname_19-6)' d='M211.09 224.07h12.41v1.66h-12.41z' />
        <path className='feature3-1_svg__cls-2' d='M420.73 187.86h170v60h-170z' />
        <text className='feature3-1_svg__cls-4' transform='translate(457.96 221.85)'>
          {'\u6587\u4EF6A'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(550.96 221.85)'>
          {'\u6587\u4EF6B'}
        </text>
        <path
          className='feature3-1_svg__cls-5'
          d='M447 205.86h-14.22v24h19.86V211zm-12.57 22.34v-20.69h10.76v5H451v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M436.09 215.79h7.73v1.66h-7.73zM436.09 219.93h12.41v1.66h-12.41zM436.09 224.07h12.41v1.66h-12.41zM541 205.86h-14.22v24h19.86V211zm-12.57 22.34v-20.69h10.76v5H545v15.69z'
        />
        <path
          className='feature3-1_svg__cls-5'
          d='M530.09 215.79h7.73v1.66h-7.73zM530.09 219.93h12.41v1.66h-12.41zM530.09 224.07h12.41v1.66h-12.41zM514.98 216.8h-8v-8h-1v8h-8v1h8v8h1v-8h8v-1z'
        />
        <path className='feature3-1_svg__cls-1' d='M379.54 153.76l5.94 1.37-2.63-6.49-3.31 5.12z' />
        <path className='feature3-1_svg__cls-13' d='M425.87 131.56l-44.39 21.68' />
        <path className='feature3-1_svg__cls-1' d='M263.54 198.76l5.94 1.37-2.63-6.49-3.31 5.12z' />
        <path className='feature3-1_svg__cls-13' d='M323.87 172.56l-58.39 25.68' />
        <path className='feature3-1_svg__cls-14' d='M151.87 231.06v27' />
        <text className='feature3-1_svg__cls-4' transform='translate(449.96 68.1)'>
          {'\u4F20\u8F93\u5B8C\u6210'}
        </text>
        <path className='feature3-1_svg__cls-14' d='M476.98 77.3v27' />
        <text className='feature3-1_svg__cls-4' transform='translate(530.96 68.1)'>
          {'\u6587\u4EF6\u4E0D\u5B8C\u6574'}
        </text>
        <path className='feature3-1_svg__cls-14' d='M547.98 77.3v27M241.87 231.06v27' />
        <path
          className='feature3-1_svg__cls-5'
          d='M660.38 152.79a23 23 0 00-5.5.78l1.24.89a11.9 11.9 0 01-4.32 0v3.66a17.49 17.49 0 007.31-.66l-.58-.7a16.06 16.06 0 011.85-.08 19.68 19.68 0 015.49.76v-3.88a23.29 23.29 0 00-5.49-.77z'
        />
        <path
          className='feature3-1_svg__cls-6'
          d='M666.21 167a16.6 16.6 0 00-3.09.6v1.08a17.81 17.81 0 01-11-.7v-3.88a16.52 16.52 0 006.7 1.34 21.33 21.33 0 003.86-.37l-.18-1a13.51 13.51 0 013.7-.94zM663.8 158.19a20.11 20.11 0 00-3.83.46l.63 1a15.88 15.88 0 01-3.92.36 18.29 18.29 0 01-6.74-1.35v3.88a19 19 0 005.86 1 19.29 19.29 0 006.19-.94l-.18-.47a15.28 15.28 0 012-.12 15.83 15.83 0 014 .38v-3.88a22.44 22.44 0 00-4.01-.32z'
        />
        <path
          className='feature3-1_svg__cls-1'
          d='M632.17 143.3h53.33v34.17h2.5v-33.68a3 3 0 00-3-3h-52.34a3 3 0 00-3 3v33.68h2.5z'
        />
        <path className='feature3-1_svg__cls-1' d='M623 177.47a3.33 3.33 0 003.33 3.33h65a3.34 3.34 0 003.34-3.33z' />
        <path
          className='feature3-1_svg__cls-5'
          d='M37.38 152.79a23 23 0 00-5.5.78l1.24.89a11.9 11.9 0 01-4.32 0v3.66a17.49 17.49 0 007.31-.66l-.58-.7a16.06 16.06 0 011.85-.08 19.68 19.68 0 015.49.76v-3.88a23.29 23.29 0 00-5.49-.77z'
        />
        <path
          className='feature3-1_svg__cls-6'
          d='M43.21 167a16.6 16.6 0 00-3.09.6v1.08a21.77 21.77 0 01-5.56.52 22 22 0 01-5.43-1.2v-3.9a16.52 16.52 0 006.7 1.34 21.33 21.33 0 003.86-.37l-.18-1a13.51 13.51 0 013.7-.94zM40.8 158.19a20.11 20.11 0 00-3.83.46l.63 1a15.88 15.88 0 01-3.92.36 18.29 18.29 0 01-6.74-1.35v3.88a19 19 0 005.86 1 19.29 19.29 0 006.19-.94l-.18-.47a15.28 15.28 0 012-.12 15.83 15.83 0 013.95.38v-3.88a22.44 22.44 0 00-3.96-.32z'
        />
        <path
          className='feature3-1_svg__cls-1'
          d='M9.17 143.3H62.5v34.17H65v-33.68a3 3 0 00-3-3H9.66a3 3 0 00-3 3v33.68h2.5z'
        />
        <path
          className='feature3-1_svg__cls-1'
          d='M0 177.47a3.33 3.33 0 003.33 3.33h65a3.34 3.34 0 003.34-3.33zM68.72 160.81h37v2h-37z'
        />
        <path className='feature3-1_svg__cls-1' d='M105.14 155.81l8 6-8 6M584.72 162.81h38v2h-38z' />
        <path className='feature3-1_svg__cls-1' d='M622.14 157.81l8 6-8 6' />
        <text className='feature3-1_svg__cls-4' transform='translate(17.76 203.12)'>
          {'\u53D1\u9001\u7AEF'}
        </text>
        <text className='feature3-1_svg__cls-4' transform='translate(639.28 203.12)'>
          {'\u63A5\u6536\u7AEF'}
        </text>
      </g>
    </g>
  </svg>
)

export default SvgFeature31
